(function employeeFileCertificateFindControllerDefinition() {
    'use strict';

    angular.module('EmployeeFileCertificate')
        .controller('EmployeeFileCertificateFindController', [
            '$scope', '$state', 'errorsExtend', 'authExtend', '$translate', 'storageService', 'certificateService', '$q', 'fileDownloader',
            function employeeFileCertificateFindController($scope, $state, errors, auth, $translate, storageService, certificateService, $q, fileDownloader) {
                $translate(['PaginationNext', 'PaginationPrev', 'PaginationFirstFem', 'PaginationLastFem'])
                    .then(function (translated) {
                        $scope.paginatorTranslations = {
                            nextText: translated.PaginationNext,
                            previousText: translated.PaginationPrev,
                            lastText: translated.PaginationLastFem,
                            firstText: translated.PaginationFirstFem
                        };
                    });

                $scope.accordionState = {
                    isOpen: false
                };

                $scope.createFilters = function () {
                    var idOu = $scope.find.organizationalUnit ? $scope.find.organizationalUnit.id : $scope.find.organizationalUnitId;

                    var filters = {
                        organizationalUnitId: idOu,
                        userId: $scope.find.employeeFile !== undefined ? $scope.find.employeeFile.userId : undefined,
                        withCertificates: $scope.find.withCertificate,
                        type: $scope.find.certificateType,
                        providerIds: $scope.find.certificateProviders,
                        expirationFrom: $scope.find.expirationDateFrom,
                        expirationTo: $scope.find.expirationDateTo,
                        itemPerPage: $scope.data.itemPerPage,
                        page: $scope.data.currentPage
                    };

                    $scope.find.showNoData = false;

                    return filters;
                };

                $scope.executeFind = function (pageChanged) {
                    var filters = $scope.createFilters();

                    if (!pageChanged) {
                        filters.page = 1;
                    }

                    return certificateService.getEmployeeFileCertificates(filters).then(function (result) {
                        $scope.employeeFileCertificatesItems = result.values;
                        $scope.data.totalItems = result.total;
                        $scope.data.from = 1 + ($scope.data.itemPerPage * ($scope.data.currentPage - 1));
                        if ($scope.employeeFileCertificatesItems.length === 0) {
                            $scope.find.showNoData = true;
                        }

                        if ($scope.employeeFileCertificatesItems.length > 0) {
                            $scope.accordionState.isOpen = false;
                            $scope.find.firstSearch = false;
                            $scope.find.showResult = true;
                        }

                        storageService.setEmployeeFileCertificatesFilter($scope.find);
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.view = function (item) {
                    $state.go('employee-file-certificate-detail', { userId: item.userId, employeeFileId: item.employeeFileId });
                };

                $scope.findAction = function () {
                    if ($scope.employeeFileCertificates !== null) {
                        if (!$scope.employeeFileCertificates.$valid) {
                            $scope.employeeFileCertificates.$setSubmitted();
                            errors.showError('VerifyFormData');
                            return false;
                        }
                    }

                    return $scope.executeFind();
                };

                $scope.cleanFilters = function () {
                    $scope.accordionState.isOpen = true;
                    storageService.clearEmployeeFileCertificatesFilter();
                    $scope.find = storageService.getEmployeeFileCertificatesFilter();
                    $scope.find.certificateProviders = $scope.certificateProviders.map(function (p) { return p.id; });

                    $scope.employeeFileCertificatesItems = [];

                    $scope.find.organizationalUnit = {
                        id: auth.getOrganizationId()
                    };
                };

                $scope.load = function () {
                    $scope.find = {
                        certificateProviders: []
                    };

                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemPerPage: 15,
                        from: 0
                    };

                    $q.all([certificateService.getTypes(), certificateService.getProviders(null, auth.getOrganizationId())]).then(function (result) {
                        $scope.certificateTypes = result[0] || [];
                        $scope.certificateProviders = result[1] || [];

                        $scope.find = storageService.getEmployeeFileCertificatesFilter();

                        if ($scope.find.firstSearch && $scope.certificateProviders) {
                            $scope.find.certificateProviders = $scope.certificateProviders.map(function (p) { return p.id; });
                        }

                        $scope.findAction();

                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.exportToExcel = function () {
                    var filters = $scope.createFilters();
                    var docName = "Legajos y Certificados";
                    var headers = ['Unidad Organizacional', 'Legajo', 'CUIL', 'Apellido', 'Nombre', 'Certificado Nación', 'Certificado Encode', 'Certificado Lakaut'];
                    return certificateService.exportToXLS(filters, headers, docName).then(function (result) {

                        var d = new Date();
                        var success = fileDownloader.saveAs(result.value, docName + '_' + d.getUTCFullYear() + '-' + (d.getUTCMonth() + 1) +
                            '-' +
                            d.getDate() +
                            '.xlsx');

                        if (!success) {
                            errors.showError('Api failed');
                        }

                    }, function (error) {
                        if (error.data && error.data.modelState.error[0] == 'empty') {
                            errors.showError('No hay resultados para exportar');
                        }
                        if (error.status === 403) {
                            errors.showError('FileForbidden');
                        } else {
                            errors.showError('Api failed');
                        }
                    });
                };

                $scope.load();
            }]);
})();